<template>
  <div style="height: 100%;">
    <ValidationObserver ref="observer" v-if="!loading">
      <v-row class="linha mt-2 mb-0 mx-0">
        <v-col cols="auto" sm="3" class="pb-0 px-0">
          <div class="mb-2">
            Situação Atual da Unimed
          </div>
          <div class="mb-2">
            <span style="width: 50px; display: inline-block;">{{ !dadosCadastrais.ativa ? 'Inativa' : 'Ativa' }}</span>
            <switch-cadu style="display: inline-block;" disabled :value="dadosCadastrais.ativa" />
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0" align="center">
        <v-col cols="12" sm="3" class="pb-0 pr-2">
          <ValidationProvider mode="eager" ref="codigo" rules="max:4|required" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Código"
              :max="'4'"
              onlyNumber
              disabled
              v-model="cdUnimed"
              :colorText="$vuetify.theme.themes.light.fontColor1"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="7" class="pb-0">
          <ValidationProvider mode="eager" rules="required|max:150" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Nome Fantasia"
              v-model="dadosCadastrais.nomeFantasia"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'150'"
              :disabled="!unimedValida"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0">
        <v-col cols="12" sm="8" md="7" class="pb-0">
          <ValidationProvider mode="eager" rules="required|max:150" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Razão Social"
              v-model="dadosCadastrais.razaoSocial"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'150'"
              :disabled="!unimedValida"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="3" md="4" class="pb-0">
          <datepicker-cadu
            inputTitle="Data da Fundação"
            :validateProviderRules="'required|dateValidatorForPass'"
            :inputValue="dadosCadastrais.dataFundacao"
            @value="(value) => (dadosCadastrais.dataFundacao = value)"
            ref="picker"
            typeCalendar="date"
            width="300"
            :disabled="!unimedValida"
          ></datepicker-cadu>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0">
        <v-col cols="12" sm="3" class="pb-0">
          <ValidationProvider mode="lazy" rules="required|cnpjValidate" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="CNPJ"
              :mask="cnpjMask"
              v-model="dadosCadastrais.cnpj"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :disabled="!unimedValida"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="4" lg="2" class="pb-0">
          <ValidationProvider mode="eager" rules="min:8|max:20" v-slot:default="{ errors }">
            <input-cadu
              style="white-space: nowrap;"
              :errorMessage="errors[0]"
              title="Inscrição Estadual"
              placeholder="ISENTO"
              colorPlaceholder="#54585e"
              v-model="dadosCadastrais.inscricaoEstadual"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'20'"
              :disabled="!unimedValida"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="4" lg="3" class="pb-0">
          <ValidationProvider mode="eager" rules="min:4|max:20" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Inscrição Municipal"
              placeholder="ISENTO"
              colorPlaceholder="#54585e"
              v-model="dadosCadastrais.inscricaoMunicipal"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'20'"
              :disabled="!unimedValida"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="4" class="pb-0">
          <autocomplete-cadu
            disabled
            title="Porte"
            v-model="dadosCadastrais.porte.nome"
            :items="portes.map((el) => el.nome)"
            :colorText="$vuetify.theme.themes.light.fontColor1"
          />
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0">
        <v-col cols="12" sm="4" class="pb-0">
          <div class="fontColor1--text pb-1" style="font-size: 1.12em;">
            Participação Societária
          </div>
          <div
            class="checkbox-group"
            :style="
              !unimedValida ? { 'background-color': '#DEE2E6 !important', opacity: '0.7', cursor: 'not-allowed' } : {}
            "
          >
            <div v-for="(participacao, index) in participacaoChecks" :key="index">
              <checkbox-cadu
                v-model="participacaoArray"
                :value="participacao.id"
                style="width: 220px;"
                :disable="!unimedValida"
              >
                <div slot="text" style="color: #54585e;">
                  {{ participacao.nome }}
                </div>
              </checkbox-cadu>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="5" class="pb-0">
          <ValidationProvider mode="eager" rules="max:80|urlValidate" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Website"
              v-model="dadosCadastrais.website"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'60'"
              :onlylowerCase="true"
              :disabled="!unimedValida"
              emailMask
            />
          </ValidationProvider>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0">
        <v-col cols="12" sm="10" class="pb-0">
          <ValidationProvider rules="max:500" v-slot="{ errors }">
            <textarea-cadu
              :errorMessage="errors[0] ? errors[0] : ''"
              title="Observações"
              v-model="dadosCadastrais.observacao"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'500'"
              :disabled="!unimedValida"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>
    <component-loading :value="loading" />
    <error-modal :value="error" @input="closeModal" :errObj="errObj" />
    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />
    <overlay-loading :value="isLoadingOverlay" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import Unimed from '@/services/Unimed'
import DadosCadastrais from '@/services/MinhaUnimed/DadosCadastrais/ViewDadosCadastrais/DadosCadastrais'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      dadosCadastrais: { id: null, porte: { id: null }, ativa: true },
      cloneDadosCadastrais: { id: null, porte: { id: null }, ativa: true },
      cdUnimed: '',
      participacaoChecks: [],
      participacaoArray: [],
      partSocietaria: [],

      all: false,
      idDados: 0,
      loading: false,
      error: false,
      menuOpen: false,
      menuOpenInativacao: false,
      dataFundacaoValue: '',
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      showModalCancelar: false,
      portes: [],

      dataFundacaoFormatada: '',
      dataFundadacaoBool: true,
      dataInativacaoFormatada: '',
      dataInativacaoBool: true,

      opcaoEditar: localStorage.getItem('optionEdit'),
      tokenBearer: localStorage.getItem('tokenBearer'),

      showModalCodigo: false,
      tituloCodigo: '',
      descricaoCodigo: '',
      isLoadingOverlay: false,
      unimedValida: true,
      cnpjMask: {
        mask: 'XX.XXX.XXX/XXXX-##',
        tokens: {
          'X': { pattern: /[A-Za-z0-9]/, transform: v => v.toUpperCase() },
          '#': { pattern: /\d/ }
        }
      }
    }
  },
  beforeDestroy() {
    localStorage.setItem('situacaoUnimed', this.dadosCadastrais.ativa)
  },
  async beforeMount() {
    this.cdUnimed = localStorage.getItem('idUnimed')
    this.loading = true
    await this.getParticipacoes()
    await this.getAllDadosCadastrias()
    this.loading = false
  },
  methods: {
    closeModal() {
      this.error = false
      this.$router.push('/administracao')
    },
    async getParticipacoes() {
      const unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      await unimed
        .getParticipacoes()
        .then((res) => {
          this.participacaoChecks = res.data
          this.participacaoArray = []
        })
        .catch((err) => {
          console.error(err)

          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async getAllDadosCadastrias() {
      const dadosCadastrais = new DadosCadastrais(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await dadosCadastrais
        .getDadosCadastrais()
        .then((res) => {
          res = res.data

          res.participacoesSocietarias.forEach((elPart) => {
            this.participacaoArray.push(elPart.id)
          })

          for (var [key, value] of Object.entries(res)) {
            if (value !== null) {
              this.dadosCadastrais[key] = value
              this.cloneDadosCadastrais[key] = value
            }
          }
        })
        .catch((err) => {
          console.error(err)

          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async validateForm() {
      const res = await this.$refs.observer.validate()

      if (res) {
        let arr = []

        this.participacaoArray.forEach((el) => {
          arr.push({ id: el })
        })

        this.dadosCadastrais.participacoesSocietarias = arr
        this.dadosCadastrais.cnpj = this.dadosCadastrais.cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase()

        const dadosCadastrais = new DadosCadastrais(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

        return await dadosCadastrais
          .putDadosCadastrais(this.dadosCadastrais)
          .then(() => {
            return true
          })
          .catch((err) => {
            console.error(err)

            this.error = true
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
            return false
          })
      }

      return false
    }
  },
  watch: {
    cdUnimed() {
      this.dadosCadastrais.cdUnimed = this.cdUnimed
      if (this.cdUnimed === '') {
        this.unimedValida = false
      }
    }
  },
  computed: {
    centralizadoTablet() {
      return this.$vuetify.breakpoint.sm
    }
  }
}
</script>

<style lang="sass" scoped>
.linha
  border-bottom: 1px solid #DEE2E6

.checkbox-group
  height: 112px
  width: 100%
  overflow: auto
  padding: 5px 0px 5px 15px
  border: #9E9E9E 1px solid
  border-radius: 5px
</style>
